import { DYNAMIC_YIELD, DY_EVENTS } from '../dynamic-yield/dy-events'
import { formatCampaignEventData } from '../dynamic-yield/dy-helpers'

const actions = {
  [DYNAMIC_YIELD]: {
    [DY_EVENTS.campaignView]: ({ data }) => formatCampaignEventData(data),
  },
}
export default actions
